export const continuationTokenHeaderName: string = 'X-Continuation';
export const waitForLoadingNewContentHeader: string = 'X-KC-Wait-For-Loading-New-Content';
export const sdkVersionHeader: string = 'X-KC-SDKID';
export const staleContentHeaderName: string = 'X-Stale-Content';

